module.exports = __webpack_public_path__ + "img/mail.b70e8ab.png";